<template>
	<b-container fluid class="d-flex flex-column mh-100 h-100 no-gutters py-0 w-100 overflow-auto">
        <b-row class="w-100 no-gutters py-0">
            <SinglePeriod :ref="$id('singlePeriod')" :Configs.sync="configs" :Variant="Variant" :Errors.sync="errorList" />
        </b-row>

        <!-- Affichage des DataBlocks et du bouton d'ajout -->
        <b-row class="w-100 no-gutters py-0 accordion">
            <!-- NewData -> Nouvelle Donnée -->
            <!--<b-button @click="newData({ Id: getNewId(), Synthesis: 'Invoice', Flow: 'Racking', Type: 'FinalEnergy', NatureStatements: [], UsePaymentDate: false,  Distribution: 'None', Filters: [], FilterExpendables: null, FilterPurposes: null, FilterUsages: null, FilterCostDetails: null, BudgetModelId: null, FilterBudgetModel: null, FilterContracts:null, FilterProviders:null, FilterTariffs:null, FilterPayingInvoice:null, FilterOwner:null, FilterObjectType:null, FilterSubscriptionHolder:null, Correctors: null, IsAccounting: false, SlidingYear: false, WithoutEstimated: false, Factors:[], Cumulate: false, Compare: false, Dissociate: false})" class="mx-2 font-weight-semibold" :variant="'outline-' + Variant" pill><b-icon icon="plus-lg" scale="0.8" /> {{ $t('NewData') }}</b-button>-->
            <b-button @click="newData({ Id: getNewId(), Synthesis: 'Invoice', ConsumptionFlow: 'Racking', FinancialFlow: 'Debit', Type: 'FinalEnergy', NatureStatements: [], IssuerType: 'Distributor', UsePaymentDate: false,  Distribution: 'None', Filters: [], FilterExpendables: null, FilterPurposes: null, FilterUsages: null, FilterCostDetails: null, BudgetModelId: null, FilterBudgetModel: null, FilterContracts:null, FilterProviders:null, FilterTariffs:null, FilterPayingInvoice:null, FilterOwner:null, FilterObjectType:null, FilterSubscriptionHolder:null, Correctors: null, IsAccounting: false, SlidingYear: false, WithoutEstimated: false, Factors:[], Cumulate: false, Compare: false, Dissociate: false})" class="mx-2 font-weight-semibold" :variant="'outline-' + Variant" pill><b-icon icon="plus-lg" scale="0.8" /> {{ $t('NewData') }}</b-button>    
            <!-- Liste des blocs de données
                 Si pb de mise à jour de tableau dataBlocks : @see https://stackoverflow.com/questions/71153245/index-in-v-for-for-array-v-if-not-updating-vue-js -->
            <DataBlock v-for="(dataBlock, index) in dataBlocks" :key="index"
                        :Index="index + 1"
                        Feature="Evolution"
                        :DataValue.sync="dataBlocks[index]"
                        :NbData="dataBlocks.length"
                        :SelectedMask="SelectedMask"
                        :UseDistribution="useDistribution"
                        :DisplaySettingsVisible="true"
                        :ShowOverlay.sync="showOverlay" :Variant="Variant"
                        @RemoveDataBlockEvent="removeData(index)"
                        @ChangeConfigCommonWorkDataEvent="changeConfigCommonWorkData(index)" />
        </b-row>
    </b-container>
</template>

<script lang="ts">
	import { Component, Watch } from 'vue-property-decorator';
	import Dictionary from '@/types/Dictionary';
	import FeatureConfigWData from './FeatureConfigWData';
	import DataBlock from './FeatureConfigWData/DataBlock.vue';
    import Data from "@/types/Config/Data";
    import SinglePeriod from './Periods/SinglePeriod.vue';


	/** Paramétrage de la fonction Evolution */
	@Component({
		components: {
			DataBlock,
            SinglePeriod
		}
	})
	export default class Evolution extends FeatureConfigWData<Data> {
	    /** Indique si la répartition est utilisée ou non */
        private useDistribution: boolean = true;

        //#region Masque de configuration
        @Watch('SelectedMask')
        private loadMask() {
            console.debug("Evolution - loadMask - SelectedMask", this.SelectedMask);

            if(this.$id("singlePeriod") in this.$refs && this.$refs[this.$id("singlePeriod")] && typeof (this.$refs[this.$id("singlePeriod")] as any).loadPeriod === "function")
                (this.$refs[this.$id("singlePeriod")] as any).loadPeriod(this.SelectedMask["Parameters"]);
        }

        /** Enregistrement du Mask pour Evolution */
        public SaveMask(): Dictionary<any> {
            let parametersValues: Dictionary<any> = {};

            parametersValues.Periods = this.configs["Periods"];
            parametersValues.Feature = this.configs["Feature"];
            parametersValues.Data = this.configs["Data"];

            return parametersValues;
        }
        //#endregion Masque de configuration

        //#region Validation des champs obligatoires

        /**
         * permet de vérifier la validité des différents champs obligatoires
         * */
        public CheckInvalidity(): boolean {
            let periodInvalid: boolean = false;
            let typeInvalid: boolean = false;

            // Vérification de l'invalidité de la période
            if(this.$id("singlePeriod") in this.$refs && this.$refs[this.$id("singlePeriod")] && typeof(this.$refs[this.$id("singlePeriod")] as any).CheckPeriodInvalidity === "function")
                periodInvalid = (this.$refs[this.$id("singlePeriod")] as any).CheckPeriodInvalidity();

            typeInvalid = this.dataBlocksInvalidity((dataBlock: Data) => {
                return dataBlock.Type == "";
            });

            if (typeInvalid)
                // NoEnergyType -> "Veuillez sélectionner un type d\'énergie sur chacune des données"
                this.errorList.push({ Message: this.$t('NoEnergyType').toString() });

            console.debug("Evolution - CheckInvalidity - isInvalid", periodInvalid || typeInvalid);

            return periodInvalid || typeInvalid;
        }
        //#endregion Validation des champs obligatoires

        /** Génération du titre */
        public GenerateTitle(): string {
            let title: string = this.GetDataBlocksTitle();

            if(this.$id("singlePeriod") in this.$refs && this.$refs[this.$id("singlePeriod")] && typeof (this.$refs[this.$id("singlePeriod")] as any).GeneratePeriodTitle === "function")
                title += (this.$refs[this.$id("singlePeriod")] as any).GeneratePeriodTitle();

            return title;
        }

		mounted() {
            console.debug("Evolution - mounted - configs : %O - configs['Periods'] : %O", this.configs, this.configs['Periods']);

            /** Initialisation des DataBlock */
            this.init(
                { Id: this.getNewId(), Synthesis: this.configs["Data"][0].Synthesis, ConsumptionFlow: this.configs["Data"][0].ConsumptionFlow, FinancialFlow: this.configs["Data"][0].FinancialFlow, Type: this.configs["Data"][0].Type, NatureStatements: [], IssuerType: this.configs["Data"][0].IssuerType, UsePaymentDate: false, Distribution: this.configs["Data"][0].Distribution, Filters: [], FilterExpendables: null, FilterPurposes: null, FilterUsages: null, FilterCostDetails: null, BudgetModelId: null, FilterBudgetModel: null, FilterContracts: null, FilterProviders: null, FilterTariffs: null, FilterPayingInvoice: null, FilterOwner: null, FilterObjectType: null, FilterSubscriptionHolder: null, Correctors: null, SlidingYear: false, WithoutEstimated: false, IsAccounting: false, Factors: [], Cumulate: false, Compare: false, Dissociate: false }
                , (dataBlock) => {
                    return (dataBlock.Synthesis != '' || dataBlock.Type!== '' || dataBlock.Flow!== '' || dataBlock.FilterExpendables > 0 || dataBlock.Distribution !== '');
                 });
		}
	}

</script>

<style scoped lang="scss">
    /** 
    Fichier .css à importer pour toutes les fonctions d'analysis (Evolution, Benchmarking, ...)
    */
    @import './analysis.scss';

    /* Met à jour la couleur de fond du switch du sélecteur de work lorsqu'il est coché */
    :deep(.custom-control-input:checked ~ .custom-control-label::before) {
            border-color: var(--Variant) !important;
            background-color: var(--Variant) !important;
        }

    /* Met à jour la couleur de fond du switch du sélecteur de work lorsqu'il est actif */
    :deep(.custom-control-input:active ~ .custom-control-label::before) {
        background-color: var(--Variant) !important;
        border-color: var(--Variant) !important;
    }
</style>